import React, { useEffect, useState } from 'react';
import EventNoteIcon from '@mui/icons-material/EventNote';
import MapIcon from '@mui/icons-material/Map';
import ForestIcon from '@mui/icons-material/Forest';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Dialog,
  Typography,
  Grid,
  TextField,
  InputLabel,
  Autocomplete,
  Box,
  createFilterOptions,
  Tooltip,
  Radio,
  Chip,
  MenuItem,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { purchseTypeRadioFields, typeOfPurchaseReqFormOption } from '../Data/HFDropDowdData';
import SectionAccordians from 'routes/Pages/components/Accordians/SectionAccordians';
import InputsRendered, { DropzoneUpload } from './InputsRendered';

import customAxios from 'routes/Pages/util/Api';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from 'routes/Pages/constants/ActionTypes';
import { useDispatch } from 'react-redux';
import authHeader from 'services/auth/jwt/auth-header';
import { useAllUsers } from 'context/AllUserDataContext';
import useHFOpsFormEditHook from '../CustomHooks/useHFOpsEditHook';
import HFClockinForm from './HFClockinForm';
import HFDailyHarvestingCloseForm from './HFDailyHarvestingCloseForm';
import HFDailyForwardingCloseForm from './HFForwardingform';
import HFOtherWorkCloseForm from './DailyWorkDataForm';
import HFCompletedForestForm from './Hf_Completedforestform.js.js';
import HFStockTakeForm from './HF_StockTake';
import HfexpenseClaimform from './HF_ExpenseClaimForm';
import HfOtherForm from './HF_OtherForm';
import HfHolidayForm from './HF_HolidayForm';
import HF_HelpVideos from './HF_HelpVideos';
import useDocs from '../CustomHooks/useDocs';
import { HF_TASK_TYPE_OPTIONS } from '../CustomHooks/useHFOpsFormAddHook';

const filter = createFilterOptions();
const EditHfFormDialog = ({ open, setOpen, selectedHfTask, handleSuccessfulSubmit }) => {
  // ── Task type (drives which form renders) ──────────────────────────
  const [currentTaskType, setCurrentTaskType] = useState(selectedHfTask?.selectTask);

  useEffect(() => {
    setCurrentTaskType(selectedHfTask?.selectTask);
  }, [selectedHfTask]);

  const {
    handleClose,
    clockInData,
    setClockInData,
    vehicalCheckList,
    setVehicalChecklist,
    spList,
    spListObj,
    harvestingClosingData,
    setHarvestingClosingData,
    harvestingMaintenanceCheckList,
    productionData,
    setProductionData,
    forwardingData,
    setForwardingData,
    forwardingMaintenanceCheckListData,
    setForwardingMaintenanceCheckListData,
    dailyOtherWorkCloseData,
    setDailyOtherWorkCloseData,
    setHarvestingMaintenanceCheckList,
    completedForestData,
    setCompletedForestData,
    setNewUploadedFiles,
    stockTakeData,
    setStockTakeData,
    expenseClaimData,
    setExpenseClaimData,
    otherTaskData,
    setOtherTaskData,
    holidayData,
    setHolidayData,
    submitEditedData,
    machineList,
  } = useHFOpsFormEditHook(selectedHfTask, currentTaskType, open, setOpen, handleSuccessfulSubmit);

  const { files, isLoading, handleFileChange, handleDeleteFiles, viewFile } = useDocs(selectedHfTask?.id);

  // ── Confirm-before-switch dialog ────────────────────────────────────
  const [pendingTaskType, setPendingTaskType] = useState(null);
  const [confirmTypeChangeOpen, setConfirmTypeChangeOpen] = useState(false);

  const handleSelectTaskType = newType => {
    if (newType === currentTaskType) return;
    setPendingTaskType(newType);
    setConfirmTypeChangeOpen(true);
  };

  const confirmTaskTypeChange = () => {
    setCurrentTaskType(pendingTaskType);
    setConfirmTypeChangeOpen(false);
    setPendingTaskType(null);
  };

  const cancelTaskTypeChange = () => {
    setConfirmTypeChangeOpen(false);
    setPendingTaskType(null);
  };

  return (
    <Dialog
      sx={{
        fontFamily: 'Normal !important',
        // overflow: 'hidden',
        '& .MuiDialog-paperScrollPaper': { overflow: 'hidden' },
      }}
      fullWidth
      maxWidth="lg"
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Edit HF {selectedHfTask?.selectTask} - ID : {selectedHfTask?.id}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={theme => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}>
        <CloseIcon />
      </IconButton>
      <form
        onSubmit={e => {
          e.preventDefault();
          submitEditedData();
        }}
        onKeyDown={e => {
          if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
            e.preventDefault();
          }
        }}>
        <DialogContent
          dividers
          sx={{
            height: '75vh', // limit modal content height to 60% viewport height
            overflow: 'auto',
          }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', height: '100%', paddingBlock: '0.5rem' }}>
            <TextField
              select
              required
              label="Select Task"
              value={currentTaskType}
              onChange={e => handleSelectTaskType(e.target.value)}
              fullWidth
              size="small">
              {HF_TASK_TYPE_OPTIONS.map(opt => (
                <MenuItem key={opt} value={opt}>
                  {opt}
                </MenuItem>
              ))}
            </TextField>

            {currentTaskType === 'Clock In' && (
              <HFClockinForm
                currentClockInData={clockInData}
                setCurrentClockInData={setClockInData}
                spList={spList}
                spListObj={spListObj}
                currentVehicalCheckList={vehicalCheckList}
                setCurrentVehicalCheckList={setVehicalChecklist}
                machineList={machineList}
              />
            )}
            {currentTaskType === 'Daily Harvesting Close' && (
              <HFDailyHarvestingCloseForm
                currDailyHarvestingData={harvestingClosingData}
                setCurrentharvestingMaintenanceCheckListData={setHarvestingMaintenanceCheckList}
                setCurrDailyHarvestingData={setHarvestingClosingData}
                spList={spList}
                spListObj={spListObj}
                productionData={productionData}
                setProductionData={setProductionData}
                currentharvestingMaintenanceCheckListData={harvestingMaintenanceCheckList}
                files={files}
                setUploadedFiles={setNewUploadedFiles}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
                handleDeleteFiles={handleDeleteFiles}
                viewFile={viewFile}
                machineList={machineList}
              />
            )}
            {currentTaskType === 'Daily Forwarding Close' && (
              <HFDailyForwardingCloseForm
                curForwardingData={forwardingData}
                setCurrForwardinggData={setForwardingData}
                currentForwardingMaintenanceCheckListData={forwardingMaintenanceCheckListData}
                setCurrentForwardingMaintenanceCheckListData={setForwardingMaintenanceCheckListData}
                productionData={productionData}
                setProductionData={setProductionData}
                spList={spList}
                spListObj={spListObj}
                files={files}
                setUploadedFiles={setNewUploadedFiles}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
                handleDeleteFiles={handleDeleteFiles}
                viewFile={viewFile}
                machineList={machineList}
              />
            )}
            {currentTaskType === 'Daily Other Work Close' && (
              <HFOtherWorkCloseForm
                forwadingMaintanceCheckListData={forwardingMaintenanceCheckListData}
                setForwadingMaintanceCheckListData={setForwardingMaintenanceCheckListData}
                harvestingMaintenanceCheckListData={harvestingMaintenanceCheckList}
                setHarvestingMaintenanceCheckListData={setHarvestingMaintenanceCheckList}
                otherTaskData={dailyOtherWorkCloseData}
                setOtherTaskData={setDailyOtherWorkCloseData}
                machineList={machineList}
              />
            )}
            {currentTaskType === 'Completed Forest' && (
              <HFCompletedForestForm
                completdForestData={completedForestData}
                setCompletedForestData={setCompletedForestData}
                productionData={productionData}
                setProductionData={setProductionData}
                spList={spList}
                spListObj={spListObj}
                files={files}
                setUploadedFiles={setNewUploadedFiles}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
                handleDeleteFiles={handleDeleteFiles}
                viewFile={viewFile}
                machineList={machineList}
              />
            )}
            {currentTaskType === 'Stock Take' && (
              <HFStockTakeForm
                productionData={productionData}
                setProductionData={setProductionData}
                spList={spList}
                spListObj={spListObj}
                stockTakeData={stockTakeData}
                setStockTakeData={setStockTakeData}
              />
            )}
            {currentTaskType === 'Expense Claim' && (
              <HfexpenseClaimform
                expenseData={expenseClaimData}
                setExpenseData={setExpenseClaimData}
                files={files}
                setUploadedFiles={setNewUploadedFiles}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
                handleDeleteFiles={handleDeleteFiles}
                viewFile={viewFile}
              />
            )}
            {currentTaskType === 'Other' && (
              <HfOtherForm
                data={otherTaskData}
                setData={setOtherTaskData}
                files={files}
                setUploadedFiles={setNewUploadedFiles}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
                handleDeleteFiles={handleDeleteFiles}
                viewFile={viewFile}
              />
            )}
            {currentTaskType === 'Holidays' && <HfHolidayForm data={holidayData} setData={setHolidayData} />}
            {currentTaskType === 'Help Videos' && <HF_HelpVideos />}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </DialogActions>
      </form>

      {/* Confirm before switching task type */}
      <Dialog open={confirmTypeChangeOpen} onClose={cancelTaskTypeChange}>
        <DialogTitle>Change Task Type?</DialogTitle>
        <DialogContent>Changing task type will clear the fields entered for the current type. Continue?</DialogContent>
        <DialogActions>
          <Button onClick={cancelTaskTypeChange}>Cancel</Button>
          <Button onClick={confirmTaskTypeChange} variant="contained" color="primary">
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

export default EditHfFormDialog;
